export const ADMIN_COMMON_PREFIX = '/api/v1/admin/auth';
export const ADMIN_PLATFORM_PREFIX = '/api/v1/admin/platform';
export const ADMIN_COMPANY_PREFIX = '/api/v1/admin/company';
export const ADMIN_REGION_PREFIX = '/api/v1/admin/region';
